// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SearchFilter_container__MmLmZ{
    position: relative;
    z-index: 50;
}
.SearchFilter_button__BHYIq{
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    height: 24px;
    padding: 12px 16px 12px 24px;
    border: 1px solid #1F363D1A;
    border-radius: 500px;
    cursor: pointer;
}
.SearchFilter_downCaret__pMCZc, .SearchFilter_upCaret__qc1eU{
    height: 7px;
    width: 12px;
    margin-left: 10px;
}
.SearchFilter_options__dq0Rs{
    position: absolute;
    right: 0;
    width: 139px;
    padding: 3px 18px;
    background-color: #FFFFFF;
    border: 1px solid #1F363D1A;
    border-radius: 10px;
    box-shadow: 0 3px 12px 0 #00000012;
}
.SearchFilter_option__Qq6Fn{
    padding-top: 15px;
    padding-bottom: 15px;
    color: #1F363D;
    font-size: 14px;
    cursor: pointer;
}
.SearchFilter_option__Qq6Fn:not(:last-child){
    border-bottom: 1px solid #1F363D1A;
}
.SearchFilter_selected__U1SGw{
    color: #40798C;
    font-family: 'Gotham Medium', serif;
}`, "",{"version":3,"sources":["webpack://./src/components/SearchFilter.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,4BAA4B;IAC5B,2BAA2B;IAC3B,oBAAoB;IACpB,eAAe;AACnB;AACA;IACI,WAAW;IACX,WAAW;IACX,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,iBAAiB;IACjB,yBAAyB;IACzB,2BAA2B;IAC3B,mBAAmB;IACnB,kCAAkC;AACtC;AACA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,cAAc;IACd,eAAe;IACf,eAAe;AACnB;AACA;IACI,kCAAkC;AACtC;AACA;IACI,cAAc;IACd,mCAAmC;AACvC","sourcesContent":[".container{\n    position: relative;\n    z-index: 50;\n}\n.button{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n    height: 24px;\n    padding: 12px 16px 12px 24px;\n    border: 1px solid #1F363D1A;\n    border-radius: 500px;\n    cursor: pointer;\n}\n.downCaret, .upCaret{\n    height: 7px;\n    width: 12px;\n    margin-left: 10px;\n}\n.options{\n    position: absolute;\n    right: 0;\n    width: 139px;\n    padding: 3px 18px;\n    background-color: #FFFFFF;\n    border: 1px solid #1F363D1A;\n    border-radius: 10px;\n    box-shadow: 0 3px 12px 0 #00000012;\n}\n.option{\n    padding-top: 15px;\n    padding-bottom: 15px;\n    color: #1F363D;\n    font-size: 14px;\n    cursor: pointer;\n}\n.option:not(:last-child){\n    border-bottom: 1px solid #1F363D1A;\n}\n.selected{\n    color: #40798C;\n    font-family: 'Gotham Medium', serif;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SearchFilter_container__MmLmZ`,
	"button": `SearchFilter_button__BHYIq`,
	"downCaret": `SearchFilter_downCaret__pMCZc`,
	"upCaret": `SearchFilter_upCaret__qc1eU`,
	"options": `SearchFilter_options__dq0Rs`,
	"option": `SearchFilter_option__Qq6Fn`,
	"selected": `SearchFilter_selected__U1SGw`
};
export default ___CSS_LOADER_EXPORT___;
